<ng-container *ngIf="showEmail">
    <div class="col-12" class="float-right" (click)="closeModal();close_popup()">
        <tc-icon [iconClass]="'icofont-close-line'" [tcFontSize]="20"> </tc-icon>
    </div>

    <div class="container" style="text-align: justify; background: transparent !important; margin-top: -9px;">
        <h4 class="text-center_second float-left getstartedtext">Get Started</h4>
        <form [formGroup]="getOtpForm" autocomplete="off">
            <div class="input-group">
                <input id="fileInput" type='Email' formControlName="userEmail" name="email" autocomplete="off"
                    placeholder="Enter your Email">
                <span class="input-group-btn">
                    <button class="btn-getotp" [disabled]="!getOtpForm.valid" (click)="sendOtpByEmail()">Get
                        OTP</button>
                </span>
            </div>
            <mat-chip-list aria-label="Fish selection">
                <div *ngIf="f.userEmail.touched && f.userEmail.invalid && !submitted" class="text-danger">
                    <div *ngIf="f.userEmail.errors && f.userEmail.errors.required">
                        <mat-chip>Please enter valid email
                        </mat-chip>
                    </div>
                </div>

                <span class="text-danger" *ngIf="!getOtpForm.controls.userEmail.valid && submitted">
                    <mat-chip>Please enter valid email
                    </mat-chip>
                </span>
            </mat-chip-list>
        </form>
        <div class="col-12" class="term_text" align="center" style="margin-top: 10%;">
            <p> By Continuing, I agree to the<span (click)="terms()">Terms of Use &
                </span> <span (click)="Privacy()">Privacy Policy</span> </p>
        </div>
        <br>
    </div>
</ng-container>

<ng-container *ngIf="!showEmail && !hideVerifyOTP">
    <div class="container">
        <h4 class="text-center_second float-left">Verify with OTP</h4>
        <div>
            <p class="form_text mail_stored float-left">Sent via Mail to {{userEmailStored}}</p>
        </div>

        <form novalidate class="form_field float-left">
            <div class="col-12">
                <ng-otp-input (onInputChange)="onOtpChange($event)" [config]="{length:4,allowNumbersOnly:true}">
                </ng-otp-input>
            </div>
            <div *ngIf="showErrorMessage" class="invalidOTP">Invalid OTP</div>
        </form>


        <div class="col-12" class="form_text float-left">
            <p>
                Didn't receive an OTP ? <span><a (click)="resendOtp()">RESEND</a></span>
            </p>
        </div>
        <br>
    </div>
</ng-container>

<ng-container *ngIf="hideVerifyOTP">
    <div class="col-12" class="float-right" (click)="closeModal();close_popup()">
        <tc-icon [iconClass]="'icofont-close-line'" [tcFontSize]="20"> </tc-icon>
    </div>

    <div class="container">
        <h4 class="text-center_second float-left">What is your name?</h4>
        <div>
            <p class="form_text mail_stored float-left">We need to call you later </p>
        </div>

        <form [formGroup]="getnameForm" autocomplete="off">
            <div class="input-group">
                <input id="fileInput" type='text' formControlName="userName" name="name" autocomplete="off"
                    placeholder="Enter your name">
                <span class="input-group-btn">
                    <button class="btn-getotp" [disabled]="!getnameForm.valid"
                        (click)="getUsernameAndOtp()">Next</button>
                </span>
            </div>

        </form>
    </div>
</ng-container>

<style>
    .text-center {
        margin-bottom: 10px !important;
        font-size: 25px;
        font-family: helvetica nue;
        color: gray;
    }

    .text-center_second {
        margin-bottom: 10px !important;
        font-size: 20px;
        font-family: helvetica nue;
        color: #463f3f;
    }

    .form_text {
        margin-bottom: 10px !important;
        font-size: 16px !important;
        /* font-family: helvetica nue; */
        color: gray;
        line-height: 2.3;
    }

    .form_text p span {
        color: #278e1b !important;
    }

    .form_field {
        font-size: 16px !important;
        font-family: helvetica nue;
    }

    .term_text span {
        font-size: 10px;
        color: #479943 !important;
        font-family: Roboto;
    }

    .term_text p {
        font-size: 10px;
        font-family: Roboto;

    }

    button {
        background-color: #479943;
        color: #ffff;
        justify-content: center;
        align-items: center;

    }

    @media only screen and (min-width: 600px) {
        .container {
            width: 424px;
            max-width: 100%;

        }

    }

    .container {
        position: relative;
        margin-left: auto;
        margin-right: auto;
        padding-right: 11px;
        padding-left: 11px;
        margin-top: -10px;
    }

    /* .container p{
                font-size: 13px;
                font-family: helvetica nue;
            } */
    .imagecookie {
        width: 60px;
        height: 60px;
        border-radius: 50%;
        overflow: hidden;
        position: absolute;
        top: -30px;
        left: calc(50% - 50px);
        margin-left: 20px;
    }

    ::ng-deep .mat-bottom-sheet-container {
        padding: 8px 16px !important;
        min-width: 100vw;
        /* min-width: 512px;
  max-width: calc(100vw - 256px) !important; */
        box-sizing: border-box;
        display: block;
        outline: 0;
        overflow: auto;
        border-top-left-radius: 16px !important;
        border-top-right-radius: 16px !important;
    }

    /* ::ng-deep .mat-bottom-sheet-container-large {
        min-width: 340px;
        max-width: calc(100vw - 256px);
    } */

    ::ng-deep.mat-bottom-sheet-container-large {
        min-width: 380px;
         /* max-width: calc(51vw - 255px);  */
         max-width: 380px;
    }

    ::ng-deep.mat-bottom-sheet-container-xlarge {
        min-width: 380px !important;
        /* max-width: calc(100vw - 384px); */
        max-width: 38px;
    }

    .actions button {
        /* background-image: linear-gradient(to right, #62AF55, #4AB07F);
         */
        background: linear-gradient(to right, #62AF55, #4AB07F);
        font-family: helvetica nue;
        height: 30px;
        width: 230px;
        color: #ffff;
        font-weight: 600;
        margin: 9px;
    }

    .btn-getotp {
        background: linear-gradient(to right, #62AF55, #4AB07F);
        font-family: helvetica nue;
        height: 40px;
        color: #ffff;
        font-weight: 600;
        font-size: 16px;
        border: none;
        border-radius: 0px 5px 5px 0px;

    }

    button[disabled] {
        opacity: 0.9;
        cursor: not-allowed !important;
    }

    .getstartedtext {
        font-family: helvetica nue;
        font-size: 18px;
        letter-spacing: 0.04px;
        line-height: 23px;
    }

    .actions img {
        margin: 10px !important;
    }

    .actions p {
        margin-top: 9px;
        text-align: center;
        font-size: 14px;
        color: #479943 !important;
        font-family: helvetica nue;
    }

    .actions_span {
        padding: 10px !important;
        color: gray;
    }

    #fileInput {
        align-items: center;
        background: #ebebeb;
        border: 1px solid #ebebeb;
        /* margin-top: 20px; */
        cursor: text;
        display: flex;
        font-family: Roboto;
        height: 40px !important;
        outline: none;
        padding: 0 1.42857143rem;
        padding: 0 calc(1.42857143rem - .2em);
        position: relative;
        transition: background 0.2s ease-in-out, border 0.2s ease-in-out, box-shadow 0.2s ease-in-out, color 0.2s ease-in-out;
        will-change: background, border, box-shadow, color;
        width: 75%;
        border-radius: 5px 0px 0px 5px;
        caret-color: #25cb7d;
    }

    :host ::ng-deep .otp-input {

        height: 60px !important;
        width: 60px !important;
    }

    .mail_stored {
        width: 367px;
    }

    .invalidOTP {
        color: #FA4747;
        margin-left: 10px;
    }

    ::ng-deep.otp-input:focus-visible {
        outline: 1px solid #25cb7d !important;
    }

    ::ng-deep.otp-input {
        border: 1px solid #25cb7d !important;
        border-radius: 8px !important;
    }
</style>